import { twMerge } from 'tailwind-merge';

interface TitleSectionProps {
  icon?: React.ReactNode;
  text: string | React.ReactNode;
  defaultIconClassName?: string;
  textClassName?: string;
}

export const TitleSection = ({
  icon,
  text,
  defaultIconClassName,
  textClassName,
}: TitleSectionProps) => {
  return (
    <div className="flex gap-2">
      {icon || (
        <i
          className={twMerge(
            'ki-filled text-purple-500 text-[26px]',
            defaultIconClassName,
          )}
        />
      )}
      <div className={twMerge('mt-0.5 font-semibold', textClassName)}>
        {text}
      </div>
    </div>
  );
};
